<template>
    <div class="knowledgebase-form">
        <div class="card-header">
            <div class="card-header__row">
                <div class="card-header__row__sort">
                    <div
                        class="sort-label"
                        :class="{'active': sort.activeName}"
                        @click.stop="sortKnowledgeBases('name')"
                    >
                        <span>
                          {{ $t('home.home.name') }}
                        </span>
                        <i
                            v-show="this.sort.activeName"
                            class="material-icons"
                        >
                            {{nameArrow}}
                        </i>
                    </div>
                    <div
                        class="sort-label"
                        :class="{'active': !sort.activeName}"
                        @click.stop="sortKnowledgeBases('modified')"
                    >
                        <span>
                          {{ $t('home.home.dateModified') }}
                        </span>
                        <i
                            v-show="!this.sort.activeName"
                            class="material-icons"
                        >
                            {{modifiedArrow}}
                        </i>
                    </div>
                </div>
                <div class="card-header__row__view-mode">
                    <svg
                        @click="changeViewMode('mode-1')"
                        id="s"
                        :class="{'active': isActive('mode-1')}"
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                        <defs>
                            <path
                                d="M4,8 L4,4 L8,4 L8,8 L4,8 Z M10,20 L10,16 L14,16 L14,20 L10,20 Z M4,20 L4,16 L8,16 L8,20 L4,20 Z M4,14 L4,10 L8,10 L8,14 L4,14 Z M10,14 L10,10 L14,10 L14,14 L10,14 Z M16,4 L20,4 L20,8 L16,8 L16,4 Z M10,8 L10,4 L14,4 L14,8 L10,8 Z M16,14 L16,10 L20,10 L20,14 L16,14 Z M16,20 L16,16 L20,16 L20,20 L16,20 Z"
                                id="path-1"
                            />
                        </defs>
                        <g id="s-view" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="KB-–-Main-Grid-hor-s" transform="translate(-1324.000000, -126.000000)">
                                <g id="Views-s" transform="translate(1320.000000, 122.000000)">
                                    <g id="icon/custom/view_grid_s">
                                        <mask id="mask-2-s" fill="white">
                                            <use xlink:href="#path-1" />
                                        </mask>
                                        <g id="Mask-s" fill-rule="nonzero" />
                                        <g
                                            id="Color-/-Icons-/-Blue-dark"
                                            class="target-path"
                                            mask="url(#mask-2-s)"
                                            :fill="currentViewColor('mode-1')"
                                            fill-rule="evenodd"
                                        >
                                            <rect id="Color-Blue-dark" x="0" y="0" width="24" height="24" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <svg
                        @click="changeViewMode('mode-2')"
                        id="l"
                        :class="{'active': isActive('mode-2')}"
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                        <defs>
                            <path
                                d="M4,8 L4,4 L11,4 L11,8 L4,8 Z M4,20 L4,16 L11,16 L11,20 L4,20 Z M4,14 L4,10 L11,10 L11,14 L4,14 Z M13,4 L20,4 L20,8 L13,8 L13,4 Z M13,14 L13,10 L20,10 L20,14 L13,14 Z M13,20 L13,16 L20,16 L20,20 L13,20 Z"
                                id="path-2"
                            />
                        </defs>
                        <g id="l-view" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="KB-–-Main-Grid-hor-l" transform="translate(-1356.000000, -126.000000)">
                                <g id="Views-l" transform="translate(1320.000000, 122.000000)">
                                    <g id="icon/custom/view_grid_l" transform="translate(32.000000, 0.000000)">
                                        <mask id="mask-2-l" fill="white">
                                            <use xlink:href="#path-2" />
                                        </mask>
                                        <g id="Mask-l" fill-rule="nonzero" />
                                        <g
                                            id="Color-/-Icons-/-Gray"
                                            class="target-path"
                                            mask="url(#mask-2-l)"
                                            :fill="currentViewColor('mode-2')"
                                            fill-rule="evenodd"
                                        >
                                            <rect id="Color-Gray" x="0" y="0" width="24" height="24" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
        <div class="card-content">
            <catalog-grid
                :current-view-mode="currentViewMode"
                :sort="sort"
            />
            <create-modal />
            <create-external />
        </div>
    </div>
</template>

<script>
import catalogGrid from '@/components/home/catalog_grid'
import createModal from '@/components/common/modals/create_modal'
import createExternal from '@/components/common/modals/create_external/create_external'

export default {
  components: {
    catalogGrid,
    createModal,
    createExternal
  },

  computed: {
    nameArrow () {
      return this.sort.nameUp ? 'arrow_upward' : 'arrow_downward'
    },

    modifiedArrow () {
      return this.sort.modifiedUp ? 'arrow_upward' : 'arrow_downward'
    }
  },

  data () {
    return {
      currentViewMode: 'mode-1',

      sort: {
        activeName: true,
        nameUp: false,
        modifiedUp: false
      }
    }
  },

  methods: {
    changeViewMode (mode) {
      if (this.currentViewMode === mode) return
      this.currentViewMode = mode
    },

    isActive (mode) {
      return this.currentViewMode === mode
    },

    currentViewColor (mode) {
      return this.currentViewMode === mode ? '#1E232B' : '#C6C6C6'
    },

    sortKnowledgeBases (sortBy) {
      if (this.sort.activeName) {
        if (sortBy === 'name') {
          this.sort.nameUp = !this.sort.nameUp
        } else {
          this.sort.activeName = false
        }
      } else {
        if (sortBy === 'name') {
          this.sort.activeName = true
        } else {
          this.sort.modifiedUp = !this.sort.modifiedUp
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .knowledgebase-form {
        display: flex;
        position: relative;
        flex-direction: column;
        height: calc(100% - 48px);
        overflow: hidden;
        background: #f6f6f6;

        .card-header {
            display: flex;
            flex-direction: column;
            z-index: 10;
            padding: 32px 32px 16px;

            $grey-text: #91969d;
            $black-text: #1e232b;

            &__row {
                display: flex;
                justify-content: space-between;

                &:last-child {
                    margin-top: 10px;
                }

                .title {
                    font-size: 22px;
                    font-weight: bold;
                    color: $black-text;
                    margin: 0;
                }

                button {
                    margin-right: -10px;
                    color: #c6c6c6;

                    &:hover {
                        color: darken(#c6c6c6, 20%);
                    }
                }

                &__sort {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: $grey-text;

                    span {
                        margin-right: 32px;
                    }

                    .sort-label {
                        display: flex;
                        position: relative;
                        align-items: center;
                        color: $grey-text;

                        &.active {
                            color: $black-text;

                            &:hover {
                                cursor: pointer;
                            }
                        }

                        &:hover {
                            cursor: pointer;
                            color: darken($grey-text, 20%);
                        }

                        &:first-child {
                            margin-right: 32px;
                        }

                        i {
                            position: absolute;
                            right: -15px;
                            bottom: 2px;
                            font-size: 13px;
                        }

                        span {
                            margin-right: 0;
                        }
                    }
                }

                &__view-mode {
                    display: flex;

                    @media (max-width: 576px) {
                        #row {
                            display: none;
                        }
                    }

                    svg {
                        margin-right: 16px;

                        &.active:hover {
                            cursor: auto;

                            .target-path {
                                fill: $black-text;
                            }
                        }

                        &:hover {
                            cursor: pointer;

                            .target-path {
                                fill: darken(#c6c6c6, 20%);
                            }
                        }

                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
        }

        .card-content {
            display: flex;
            flex-grow: 1;
            position: relative;
            padding: 0;
            overflow: hidden;
        }
    }
</style>
